import { Types } from "../actions/EquipmentAction";

const initialState = {
    actionResult: {},
    equipmentListByArea: [],
    eqSubList: [],
    eqByBarCode: {},
    eqDetailList: {},
    deletedEq: {},
    equipmentAgainstId: {},
    eqReportAgainstId: {},
    eqReportList: {},
    equipmentGroupInfo: {},
    plants: {},
    eqTypes: {},
    areas: {},
    costCenters: {},
    eqMainList: {},
    eqRes: {},
    equipmentFiles: null,
};

export const equipmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_EQ_MAIN_LIST_BY_AREA:
            return {
                ...state,
                equipmentListByArea: action.payload || state.equipmentListByArea,
            };
        case Types.EQ_MAIN_LIST_BY_AREA_FAILURE:
            return {
                ...state,
                actionResult: action.payload || state.actionResult,
            };
        case Types.SET_EQUIPMENT_SUBLIST_BY_ID:
            return {
                ...state,
                eqSubList: action.payload || state.eqSubList,
            };
        case Types.SET_EQUIPMENT_BY_BAR_CODE:
            return {
                ...state,
                eqByBarCode: action.payload || state.eqByBarCode,
            };
        case Types.SET_EQ_DETAIL_LIST:
            return {
                ...state,
                eqDetailList: action.payload || state.eqDetailList,
            };
        case Types.DELETE_EQUIPMENT_RES:
            return {
                ...state,
                deletedEq: action.payload || state.deletedEq,
            };
        case Types.RESET_DETAIL_LIST:
            return {
                ...state,
                eqDetailList: {},
            };
        case Types.SET_EQ_DETAIL_BY_ID:
            return {
                ...state,
                equipmentAgainstId: action.payload || state.equipmentAgainstId,
            };
        case Types.SET_EQ_REPORT_GROUP_LIST:
            return {
                ...state,
                eqReportList: action.payload || state.eqReportList,
            };
        case Types.SET_EQUIPMENT_REPORT_GROUP_BY_ID:
            return {
                ...state,
                eqReportAgainstId: action.payload || state.eqReportAgainstId,
            };
        case Types.SET_EDIT_GROUP_INFO:
            return {
                ...state,
                equipmentGroupInfo: action.payload || state.equipmentGroupInfo,
            };
        case Types.RESET_EDIT_GROUP_INFO:
            return {
                ...state,
                equipmentGroupInfo: {},
            };
        case Types.SET_COST_CENTER_FOR_EQ:
            return {
                ...state,
                costCenters: action.payload || state.costCenters,
            };
        case Types.SET_AREA_FOR_EQ:
            return {
                ...state,
                areas: action.payload || state.areas,
            };
        case Types.SET_PLANT_LIST:
            return {
                ...state,
                plants: action.payload || state.plants,
            };
        case Types.SET_EQ_TYPES:
            return {
                ...state,
                eqTypes: action.payload || state.eqTypes,
            };
        case Types.SET_EQ_MAIN_LIST:
            return {
                ...state,
                eqMainList: action.payload || state.eqMainList,
            };
        case Types.SET_EDIT_EQUIPMENT:
            return {
                ...state,
                eqRes: action.payload || state.eqRes,
            };
        case Types.SET_ADD_EQUIPMENT:
            return {
                ...state,
                eqRes: action.payload || state.eqRes,
            };
        case Types.RESET_EQ_RES:
            return {
                ...state,
                eqRes: {},
            };
        case Types.RESET_DELETED_EQ:
            return {
                ...state,
                deletedEq: {},
            };
        case Types.RESET_EQ_GROUP:
            return {
                ...state,
                equipmentAgainstId: {},
                eqReportAgainstId: {},
                eqReportList: {},
            };
        case Types.RESET_EQ_MAIN_LIST:
            return {
                ...state,
                eqMainList: {},
            };
        case Types.SET_EQUIPMENT_FILES:
            return {
                ...state,
                equipmentFiles: action.payload || state.equipmentFiles,
            };

        default:
            return state;
    }
};
